import axios from "axios";

import { HEALTHCARE_API } from "@modules/common/constants";

export type NoomIntakeCompletionType =
  | "PHARMACY_SWITCH"
  | "CONCENTRATION_CHANGE"
  | "CONCENTRATION_CHANGE_INCREASE"
  | "COMPOUND_FORMULATION_CHANGE";

export const updateNoomIntakeStatus = async (
  accessCode: string,
  accessToken: string,
  intakeType: NoomIntakeCompletionType
): Promise<void> => {
  await axios.post(
    `${HEALTHCARE_API}/noom-intakes/${accessCode}/status`,
    { type: intakeType, status: "COMPLETE" },
    {
      headers: {
        Authorization: `bearer ${accessToken}`,
      },
    }
  );
};
